import React from "react";
import { Banner, Icon } from "@bookingcom/bui-react";
import { Trans } from "@bookingcom/lingojs-react";
import { InfoSignIcon } from "@bookingcom/bui-assets-react/streamline";
import { isFeatureRunningClientSide } from "@flights/web-api-utils-universal";
export const MiddleEastBanner = () => {
    if (!isFeatureRunningClientSide("FLIGHTS_WEB_PB_CS_HIGH_VOLUMES_BANNER")) {
        return undefined;
    }
    return (React.createElement(Banner, { variant: "callout", dismissible: false, title: React.createElement(Trans, { tag: "flights_pb_middle_east_banner_title" }), text: React.createElement(Trans, { tag: "flights_pb_middle_east_banner_body", variables: {
                start_bold: "<0>",
                end_bold: "</0>"
            }, components: [React.createElement("strong", { key: 0 })] }), startIcon: React.createElement(Icon, { size: "medium", color: "callout", svg: InfoSignIcon }) }));
};
